export { default as SEO } from "./seo/seo"
export { default as Layout } from "./layout/layout"
export { default as Nav } from "./nav/nav"
export { default as Header } from "./header/header"
export { default as ModularPage } from "./modular-page/modular-page"
